export default {
  namespaced: true,
  state: {
    viewedChangeRequest: null,
    viewedChangeRequestOrig: null,
    viewedChangeRequestDialog: false,
    changeRequestPos: null,
    viewedAddShopDialog: false,
    viewedAddPosDialog: false,
    addPosShopObjectId: false,
    addPosShopName: false
  },
  mutations: {
    setViewedChangeRequest: (state, payload) => {
      // load shop or pos for edition
      // copy of payload
      var changeRequest = JSON.parse(JSON.stringify(payload))
      if (changeRequest.localizations === undefined) {
        changeRequest.localizations = []
      }
      changeRequest.proof_comment = ''
      changeRequest.localizations.unshift({
        'name': changeRequest.name,
        'localization_text': 'Apply to all POS',
        'note': changeRequest.note,
        'url': changeRequest.url,
        'who': changeRequest.who_intersection,
        'what': changeRequest.what_intersection,
        'how': changeRequest.how_intersection,
        'other': changeRequest.other_intersection,
        'description': changeRequest.description,
        'data_rejected': [],
        'data_validated': [],
        'localization_id': -1,
        'object_id': changeRequest.objectID
      })
      var normalTypeFields = ['name', 'localization_text', 'note', 'url', 'description']
      var m2oTypeFields = ['who', 'what', 'how', 'other']
      for (const localization of changeRequest.localizations) {
        localization['name'] = changeRequest.name
        localization['data_rejected'] = []
        localization['data_validated'] = []
        for (const fieldName of normalTypeFields) {
          localization[fieldName + '_update'] = ''
          localization[fieldName + '_comment'] = ''
        }
        for (const fieldName of m2oTypeFields) {
          localization[fieldName + '_update'] = []
          localization[fieldName + '_rejected'] = []
          localization[fieldName + '_validated'] = []
          localization[fieldName + '_comment'] = ''
        }
      }
      state.viewedChangeRequest = changeRequest
      state.viewedChangeRequestOrig = JSON.parse(JSON.stringify(changeRequest))
    },
    setViewedChangeRequestPos: (state, display) => {
      state.changeRequestPos = display
    },
    setViewedChangeRequestDialog: (state, display) => {
      state.viewedChangeRequestDialog = display
    },
    setViewedAddShopDialog: (state, display) => {
      state.viewedAddShopDialog = display
    },
    setViewedAddPosDialog: (state, display) => {
      state.viewedAddPosDialog = display
    },
    setAddPosShopObjectId: (state, display) => {
      state.addPosShopObjectId = display
    },
    setAddPosShopName: (state, display) => {
      state.addPosShopName = display
    }
  },
  actions: {
    async createNewShop ({ commit, state, dispatch, rootState }, { newShop }) {
      commit('setProgressLinear', true, { root: true })
      // TODO
      // var normalTypeFields = ['name', 'localization_text', 'note', 'url', 'description']
      // var m2oTypeFields = ['who', 'what', 'how', 'other']
      // var operations = []
      // // process normal field type
      // for (const localization of newShop.localizations) {
      //   for (const fieldName of normalTypeFields) {
      //   }
      // }
      commit('setProgressLinear', false, { root: true })
      // return response
    }
  },
  getters: {
  }
}
